import { selectAuth } from "@redux";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { ComponentTopSpenderList } from "src/Components/TopSpender/List";
import { IGetWebsaleTopSpenderExample } from "src/Interfaces/topCharoen";

export const PageTopSpenderList = () => {
    const { userInfo } = useSelector(selectAuth);
    const dispatch = useDispatch();
    const history = useHistory();
    const [loggedInUser, setLoggedInUser] = useState<IGetWebsaleTopSpenderExample>();

    return <ComponentTopSpenderList userInfo={userInfo} loggedInUser={loggedInUser} />;
};
